"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_SubstanceSourceMaterial = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_SubstanceSourceMaterial_FractionDescription_1 = require("./RTTI_SubstanceSourceMaterial_FractionDescription");
var RTTI_SubstanceSourceMaterial_Organism_1 = require("./RTTI_SubstanceSourceMaterial_Organism");
var RTTI_SubstanceSourceMaterial_PartDescription_1 = require("./RTTI_SubstanceSourceMaterial_PartDescription");
exports.RTTI_SubstanceSourceMaterial = t.recursion('ISubstanceSourceMaterial', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('SubstanceSourceMaterial')
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            sourceMaterialClass: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            sourceMaterialType: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            sourceMaterialState: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            organismId: RTTI_Identifier_1.RTTI_Identifier,
            organismName: t.string,
            _organismName: RTTI_Element_1.RTTI_Element,
            parentSubstanceId: t.array(RTTI_Identifier_1.RTTI_Identifier),
            parentSubstanceName: t.array(t.string),
            _parentSubstanceName: t.array(RTTI_Element_1.RTTI_Element),
            countryOfOrigin: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            geographicalLocation: t.array(t.string),
            _geographicalLocation: t.array(RTTI_Element_1.RTTI_Element),
            developmentStage: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            fractionDescription: t.array(RTTI_SubstanceSourceMaterial_FractionDescription_1.RTTI_SubstanceSourceMaterial_FractionDescription),
            organism: RTTI_SubstanceSourceMaterial_Organism_1.RTTI_SubstanceSourceMaterial_Organism,
            partDescription: t.array(RTTI_SubstanceSourceMaterial_PartDescription_1.RTTI_SubstanceSourceMaterial_PartDescription)
        })
    ]);
});
//# sourceMappingURL=RTTI_SubstanceSourceMaterial.js.map